// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__gw6om","header":"MergedInvoice_header__3g7h1"};